import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import padStart from 'lodash/padStart';
import moment, { Moment } from 'moment-timezone';
import React from 'react';
import Calendar from 'react-calendar';
import styles from './MonthPicker.module.scss';

interface MonthPickerProps {
    timeZone: string;
    month: Moment;
    onChange: (date: Moment) => void;
}

export const MonthPicker: React.FC<MonthPickerProps> = ({ timeZone, month, onChange }) => {
    const selectMonth = (date: Date) => {
        const ddmmyyyy = `${padStart(date.getDate().toString(), 2, '0')}${padStart(
            (date.getMonth() + 1).toString(),
            2,
            '0'
        )}${date.getFullYear()}`;
        onChange(moment.tz(ddmmyyyy, 'DDMMYYYY', timeZone).clone().startOf('month'));
    };

    return (
        <Calendar
            calendarType="US"
            onClickMonth={selectMonth}
            value={month.format('YYYY/MM/DD')}
            className={styles.calendar}
            nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
            prevLabel={<FontAwesomeIcon icon={faChevronLeft} />}
            prev2Label={null}
            next2Label={null}
            showNeighboringMonth={false}
            locale={'en'}
            defaultView="year"
            maxDetail="year"
        />
    );
};

export default MonthPicker;
